import * as SearchService from "@omni/services/search/search.service";
import { AlgoliaSearchParams } from "@omni/types/api/search/algolia/search/algoliaSearchParams.model";
import { IndexEntity } from "@omni/types/api/search/algolia/shared/enum/indexEntity.enum";
import { cleanUpObjRecursive } from "@omni/utils/object.utils";

import { ProductAlgoliaModel } from "@/types/service/algolia/product.algolia.model";
import { Config } from "@/utils/config.utils";

import { getProductsFromResponse } from "./helpers/response.helpers";
import { AlgoliaClient } from "./types/client.types";
import { AlgoliaSearchQuery } from "./types/search.types";

const searchProducts =
    (searchClient: AlgoliaClient) =>
    ({ query, limit, filters, sort }: AlgoliaSearchParams) =>
        searchClient
            .searchForHits<ProductAlgoliaModel>({
                requests: [
                    cleanUpObjRecursive({
                        indexName: SearchService.compileIndex({
                            environment: Config.general.environment,
                            baseStore: Config.general.basestore,
                            locale: Config.getLocale(),
                            indexEntity: IndexEntity.Products,
                            indexSort: sort,
                            indexType: undefined
                        }),
                        query,
                        hitsPerPage: limit,
                        page: 0,
                        filters: filters
                    }) satisfies AlgoliaSearchQuery
                ]
            })
            .then(getProductsFromResponse);

export { searchProducts };
